import { render } from "./ThinkerSectionComponent.vue?vue&type=template&id=f0a10ac8&scoped=true"
import script from "./ThinkerSectionComponent.vue?vue&type=script&lang=js"
export * from "./ThinkerSectionComponent.vue?vue&type=script&lang=js"

import "./ThinkerSectionComponent.vue?vue&type=style&index=0&id=f0a10ac8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0a10ac8"]])

export default __exports__